module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h001"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REETINGS FROM")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERO")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LANC")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Dear Friends,")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("What would holidays and family gatherings be without special recipes passed along and shared? Our own memories of childhood are irrevocably connected to the wonderful smells of baking that filled relatives’ homes when we arrived for a visit: pies and angel-food cakes made proudly from scratch, the dough carefully kneaded and rolled, the egg whites beaten by hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the spirit of those happy and bygone days, we dedicate this book to the memory of Cordelia’s mother, Cordelia Frances Fenton Biddle, and to her mother, Mary Frances Higgins Fenton, who made the very best fudge in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And we also give many thanks to Midge Walter and her son, Tony, of Lore’s Chocolates in Philadelphia. As current residents of the city, we can promise you that holidays aren’t the same without numerous samplings of Lore’s wares. Tony provided technical information as well as a glimpse into the workings of a true confectionery shop. If you’re in Philadelphia, be sure to visit their store on Seventh Street. It’s a pure delight!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Please remember that our website "), _c('a', {
    attrs: {
      "href": "http://www.CrosswordMysteries.com",
      "target": "_blank"
    }
  }, [_vm._v("www.CrosswordMysteries.com")]), _vm._v(" has puzzles to download, and that we do love getting your letters.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("Cordelia and Steve")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15cdaa12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter.vue
// module id = 72
// module chunks = 0